import { BaseComponent } from 'app/base';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DatatableClickEvent } from '@basis/angular-components';
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'interpor-recurso',
    templateUrl: './interpor-recurso.component.html',
})
export class InterporRecursoComponent extends BaseComponent {
    @Input() eventClickRecurso: DatatableClickEvent;
    @Input() controller: string;
    texto: string;

    @Input() visible: boolean;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    display: boolean;

    init() {
        switch (this.controller) {
            case 'capacitadora':
                this.texto = 'A capacitadora selecionada está aberta para recurso. Deseja realmente interpor recurso?';
                break;
            case 'gerenciamento-banca':
            case 'gerenciamento-comissao':
            case 'gerenciamentoCurso':
            case 'gerenciamentoCursoExterior':
            case 'gerenciamentoDocencia':
            case 'gerenciamentoEvento':
            case 'gerenciamento-pos-graduacao':
            case 'gerenciamentoProducaoIntelectual':
            case 'gerenciamentoJustificativa':
            default:
                this.texto = 'A atividade selecionada está aberta para recurso. Deseja realmente interpor recurso?'
                break;
        }
    }

    close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    interporRecurso(event: DatatableClickEvent) {
        const obj = event.selection;
        this.router.navigate(['./abrir-recurso', obj['id']], { relativeTo: this.activatedRoute });
    }
    naoInterporRecurso(event: DatatableClickEvent) {
        const obj = event.selection;
        this.naoAbrirRecurso(obj[`id`], this.controller, false);
        this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/interpor-recurso/interpor-recurso.component.ts